import SendInspectLog from "./SendInspectLog.vue";
export default SendInspectLog;
